import { Box, Typography } from "@vp/swan";
import React from "react";
import { useLocalization } from "../hooks/useLocalizations";

export type MinimumOrderableQuantityProps = {
  quantity: number;
  alwaysShowMOQInfo?: boolean;
};

// Implement a helper function, getMoqText, to generate the text to display based on the moq value:
//  - If moq is greater than 1, return a formatted string indicating the minimum number of units required.
//  - If moq is 1 or less, return an empty string, indicating no specific message is needed.

export const MinimumOrderableQuantity = ({ quantity, alwaysShowMOQInfo }: MinimumOrderableQuantityProps) => {
  const { t } = useLocalization();
  const getMoqText = (): string => {
    if (quantity > 1) {
      return t("price-platform.minimum-quantity.value", { 0: quantity }) as string;
    } else {
      if (alwaysShowMOQInfo) {
        return t("price-platform.no-minimum-quantity.value") as string;
      }
      return "";
    }
  };

  return (
    <Typography>
      <Box>{getMoqText()}</Box>
    </Typography>
  );
};
